import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelKpis } from "../types";

export const useClientModelKpis = (model_id: number) => {
  return useQuery({
    queryKey: ["client", "model", "kpis", model_id],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/kpis`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelKpis;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
